export default __webpack_public_path__ + "static/media/wallet.e3a9d8a3.jpg";